module.exports = __webpack_public_path__ + "img/box_pro_three_2.2756e928.jpg";